<template>
    <div
        class="z-color-select"
        v-click-outside="hideList"
        v-bind:class="{
            'focused': showColors,
            'has-error': (error && error.length),
        }"
    >
        <div class="z-color-select-container" v-bind:class="{'focused': showColors}">
            <label class="label" v-if="label"> {{$props.label}} </label>
            <div class="preview" v-on:click="toggleColors">
                <div v-if="colorValue" class="value active-icon" v-bind:style="'background-color: ' + colorValue"></div>
                <span>{{ colorLabel ? colorLabel[listLabel] : $props.placeholder }}</span>
                <div class="btn"></div>
            </div>
        </div>
        <div class="colors-container" v-show="showColors">
            <div class="colors">
                <div class="color" v-for="(color, i) in $props.colors" v-bind:key="`simple-color-input-${uid}-${i}`">
                    <label
                        v-bind:class="{
                            'color__label': true,
                            'active': colorValue == color[listValue],
                        }"
                        v-bind:for="`simple-color-input-${uid}-${i}`"
                    >
                        <i class="color__value" v-bind:style="'background-color: ' + color[listValue] + ';'"></i>
                        {{ color[listLabel] }}
                    </label>
                    <input
                        v-bind:id="`simple-color-input-${uid}-${i}`" type="radio"
                        v-bind:value="color[listValue]"
                        v-on:click="toggleColors"
                        v-model="colorValue"
                        v-bind:name="$props.name"
                    >
                </div>
            </div>
        </div>
        <span class="z-error" v-if="error">{{error}}</span>
    </div>
</template>
<script>
    import ClickOutside from 'vue-click-outside';
    export default {
        directives: {ClickOutside},
        props: {
            value: {
                type: String,
                default: ''
            },
            id: {
                type: String,
                default: 'z-color-selector'
            },
            name: {
                type: String,
                default: 'z-color-selector'
            },
            error: {
                type: String,
                default: ''
            },
            colors: { //[{label: 'Black', value: '#000'}, {label: 'White', value: '#fff'}]
                type: Array,
                default: () => []
            },
            label: {
                type: String,
                default: ''
            },
            listValue: {
                type: String,
                default: 'value'
            },
            listLabel: {
                type: String,
                default: 'label'
            },
            placeholder: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                showColors: false,
                viewColors: [],
                colorValue: '',
            }
        },
        computed: {
            uid() {
                return this._uid
            },
            colorLabel() {
                return this.$props.colors.find(i =>  i[this.listValue] == this.colorValue)
            }
        },
        watch: {
            'colorValue'(val) {
                this.$emit('input', val);
            },
            '$props.value'(val) {
                if (this.colorValue != val) this.colorValue = val;
            },
        },
        methods: {
            toggleColors() {
                this.showColors = !this.showColors
            },
            hideList() {
                this.showColors = false;
            }
        }
    }
</script>
<style lang="sass">
   .z-color-select
        width: 100%
        margin: 4px 0 10px 0
        position: relative
        .z-error
            display: block
            height: auto
            min-height: 15px
            font-size: 11px
            line-height: 11px
            padding: 8px 0 0
            color: #ff1744
        &.has-error
            .preview
                background: rgba(214, 101, 101, 0.1)
                border: 1px solid #D66565
        .z-color-select-container
            position: relative
        .preview
            display: flex
            align-items: center
            justify-content: flex-start
            flex-wrap: wrap
            font-size: 14px
            border: none
            background: transparent
            outline: none
            color: #000
            font-weight: 400
            min-height: 26px
            width: 100%
            position: relative
            z-index: 10
            background: #F1F1F1
            padding: 2px 5px

            &.can-add
                width: calc(100% - 24px)
            .input-label
                margin: 0 5px
            .value
                display: block
                width: 19px
                height: 19px
                background: #c57373
                border-radius: 100%
                border: 1px solid gray
                margin: 0 5px 0 0
                transition: var(--transition-fast-smooth)
            .btn
                display: flex
                align-items: center
                justify-content: center
                margin: auto 0 auto auto
                width: 26px
                height: 26px
                transition: 0.2s ease-in-out
                &::before
                    content: ''
                    display: block
                    width: 10px
                    height: 10px
                    border-bottom: 1px solid #000
                    border-right: 1px solid #000
                    transform: rotate(45deg)
                    margin: -5px 0 0 0
        &.focused
            .preview
                .btn
                    transform: rotate(90deg)
        .label
            display: block
            color: rgba(0, 0, 0, 0.54)
            font-size: 12px
            font-weight: 500
            line-height: 12px
            transition: .4s cubic-bezier(.25,.8,.25,1)
            transition-duration: .3s
            z-index: 5
            resize: none
            margin-bottom: 10px
            span
                color: #D66565
            sub, sup
                line-height: 0
        .colors
            display: flex
            align-items: center
            justify-content: flex-start
            cursor: default
            flex-direction: column
            width: 100%
            .color
                width: 100%
                input
                    margin: 0
                    padding: 0
                    opacity: 0
                    display: none
                    visibility: hidden
            .color__label
                display: flex
                align-items: center
                justify-content: flex-start
                outline: none
                padding: 5px
                transition: var(--transition-fast-smooth)
                .color__value
                    display: block
                    width: 19px
                    height: 19px
                    background: transparent
                    border-radius: 100%
                    border: 1px solid gray
                    margin: 0 5px 0 0
            .active
                background: #F1F1F1
                .color__value
                    border: 1px solid #bbd4ff
        .colors-container
            background: #fff
            box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 1px 3px 0 rgba(0, 0, 0, 0.12)
            z-index: 1000
            min-width: 100%
            max-height: 300px
            overflow-y: auto
            overflow-x: hidden
            position: absolute
            transition: var(--transition-fast-smooth)
</style>


// WEBPACK FOOTER //
// ZColorSelector.vue?445ecff8